export default "__VITE_ASSET__D696dJVE__"